import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageHeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '20px',
});

export const TitleSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const BackButton = styled(IconButton)({
  width: '35px',
  height: '35px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #DFDFDF',
  boxShadow: '0px 1px 3px rgba(0, 53, 114, 0.12)',
  borderRadius: '16px',
  '&:hover': {
    backgroundColor: '#F1F7FF',
  },
});

export const BackIcon = styled(Box)({
  fontSize: '20px',
  color: '#75838A',
});

export const PageTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '28px',
  fontWeight: 600,
  color: 'var(--primary-blue)',
});

export const OrderPageTitle = styled(Typography)`
  font-family: 'Outfit';
  font-weight: 500;
  font-size: 24px;
  color: #75838a;
`;

export const PrimaryActionButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  backgroundColor: 'var(--primary-blue)',
  color: 'var(--bg-color)',
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 600,
  padding: '8px 16px',
  borderRadius: '8px',
  border: 'none',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'var(--hover-blue)',
  },
});

export const ButtonIcon = styled(Box)({
  fontSize: '20px',
});
